/* lystia-tabbar.js - TabBar M (T-E2-16, parity/shell.md §4). Нативний ES-клас, без глобалів.
   Шторки catalog/cart/menu: document.lystiaOverlay (lystia-overlay.js); повторний тап по вкладці відкритої шторки закриває її.
   Активна вкладка: відкрита шторка (власна вкладка; чужа шторка - жодної) має пріоритет над маршрутом (data-route-active).
   Бейдж/aria кошика: cart:change (lystia-cart.js). Автоприховування: лише якщо [data-autohide] (PDP): пороги 6/120/60.
   Клавіатура: Tab циклічно проходить панель повноекранної шторки (Меню) і TabBar (спека menu.md §5). */
(function () {
  'use strict';

  const FOCUSABLE = 'a[href],button:not([disabled])';

  class LystiaTabbar {
    constructor(host) {
      this.host = host;
      this.tabs = Array.prototype.slice.call(host.querySelectorAll('[data-tab]'));
      this.cart = host.querySelector('[data-tab="cart"]');
      this.badge = host.querySelector('[data-cart-count]');
      this.routeActive = host.getAttribute('data-route-active') || '';
      this.lastY = window.scrollY;
      this.hidden = false;

      if (host.hasAttribute('data-autohide')) document.body.classList.add('tabbar-autohide');

      this.tabs.forEach((t) => t.addEventListener('click', (e) => this.onTab(e, t)));
      document.addEventListener('lystia:overlay-open', () => this.syncActive());
      document.addEventListener('lystia:overlay-close', () => this.syncActive());
      window.addEventListener('popstate', () => setTimeout(() => this.syncActive(), 0));
      document.addEventListener('cart:change', (e) => {
        const c = e.detail && e.detail.cart;
        if (c && typeof c.item_count === 'number') this.setCount(c.item_count);
      });
      window.addEventListener('scroll', () => this.onScroll(), { passive: true });
      host.addEventListener('focusin', () => this.setHidden(false));
      document.addEventListener('keydown', (e) => this.onKey(e), true);
      this.syncActive();
    }

    get ov() { return document.lystiaOverlay || null; }

    /* ---------- вкладки ---------- */
    onTab(e, tab) {
      const name = tab.getAttribute('data-tab-overlay');
      if (!name || !this.ov) return;
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (this.ov.current() === name) {
        e.preventDefault();
        this.ov.close();
        this.syncActive();
        return;
      }
      if (this.ov.has(name)) {
        e.preventDefault();
        this.ov.open(name);
      }
      /* шторки нема: <a> працює як посилання, <button> без дії */
    }

    syncActive() {
      const cur = this.ov ? this.ov.current() : null;
      let act;
      if (cur) act = this.tabs.some((t) => t.getAttribute('data-tab') === cur) ? cur : '';
      else act = this.routeActive;
      this.tabs.forEach((t) => {
        const on = t.getAttribute('data-tab') === act;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current');
        const svg = t.querySelector('svg');
        if (svg) svg.setAttribute('stroke-width', on ? '2' : '1.5');
      });
    }

    /* ---------- кошик ---------- */
    setCount(n) {
      if (this.badge) {
        this.badge.textContent = n > 9 ? '9+' : String(n);
        this.badge.hidden = n === 0;
      }
      if (!this.cart) return;
      if (n <= 0) { this.cart.removeAttribute('aria-label'); return; }
      const m100 = n % 100, m10 = n % 10;
      const form = m100 >= 11 && m100 <= 14 ? 'many' : m10 === 1 ? 'one' : m10 >= 2 && m10 <= 4 ? 'few' : 'many';
      /* шаблон форми містить зразок числа (1/2/5) - підміняємо на n */
      const tpl = this.cart.getAttribute('data-label-' + form);
      if (tpl) this.cart.setAttribute('aria-label', tpl.replace(/\d+/, String(n)));
    }

    /* ---------- автоприховування ---------- */
    setHidden(on) {
      if (on === this.hidden) return;
      this.hidden = on;
      document.body.classList.toggle('tabbar-hidden', on);
    }

    onScroll() {
      if (document.lystia && document.lystia.scrollLock.locked) return;
      const y = window.scrollY;
      if (document.body.classList.contains('tabbar-autohide')) {
        if (y > this.lastY + 6 && y > 120) this.setHidden(true);
        else if (y < this.lastY - 6 || y < 60) this.setHidden(false);
      } else this.setHidden(false);
      this.lastY = y;
    }

    /* ---------- клавіатура: TabBar лишається досяжним під повноекранною шторкою ---------- */
    visible() { return getComputedStyle(this.host).display !== 'none' && !this.hidden; }

    onKey(e) {
      if (!this.ov) return;
      const panel = this.ov.panel();
      const full = panel && panel.closest('.ov--fullscreen');
      if (!full || !this.visible()) return;
      const inBar = this.host.contains(document.activeElement);
      if (e.key === 'Escape' && inBar) { e.preventDefault(); this.ov.close(); this.syncActive(); return; }
      if (e.key !== 'Tab') return;
      const bar = Array.prototype.slice.call(this.host.querySelectorAll(FOCUSABLE));
      const items = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE + ',input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'))
        .filter((x) => x.offsetParent !== null);
      if (!bar.length) return;
      const go = (el) => { if (el) { e.preventDefault(); e.stopPropagation(); el.focus(); } };
      const a = document.activeElement;
      if (inBar) {
        if (!e.shiftKey && a === bar[bar.length - 1]) go(items[0]);
        else if (e.shiftKey && a === bar[0]) go(items[items.length - 1]);
      } else if (items.length && panel.contains(a)) {
        if (!e.shiftKey && a === items[items.length - 1]) go(bar[0]);
        else if (e.shiftKey && a === items[0]) go(bar[bar.length - 1]);
      }
    }
  }

  const host = document.querySelector('[data-lystia-tabbar]');
  if (host) new LystiaTabbar(host);
})();
